var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { space } from 'styled-system';
import { styled } from "../utils";
var StyledHr = styled.hr(space);
StyledHr.defaultProps = {
    my: [1, 3],
};
var Hr = function (props) { return React.createElement(StyledHr, __assign({ "data-component": "Hr" }, props)); };
export default Hr;
//# sourceMappingURL=Hr.js.map